// @ts-nocheck
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit } from "@fortawesome/free-regular-svg-icons";
import { faUpload, faDownload, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import BackButton from "components/Button/BackButton";
import "./UsersManager.css";
import Button from "components/Button/Button";
import UsersExporter from "./components/UsersExporter/UsersExporter";
import TagsList from "components/Tags/TagsList/TagsList";
import useAccount from "classes/Accounts/hooks/useAccount";
import genRequest from "includes/request";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import { t } from "i18next";

const items = [
	{
		key: 0,
		title: "Contacts.EXPORT_USERS",
		component: UsersExporter,
		icon: faUpload,
		props: {
			tableClassName: "dark-bg"
		},
	},
	{
		key: 1,
		title: "Contacts.IMPORT_USERS",
		role: "EloAdmin",
		disabled: true,
		component: false,
		icon: faDownload
	}
];

export default function UsersManager(props) {

	const { isSup } = useAccount();
	const [active, setActive] = useState(false);
	const count = React.useRef();

	const getItems = React.useCallback(() => {
		let ret = items.filter(a => {
			if (a.role && isSup(a.role) < 0)
				return (false);
			return (a);
		});
		return (ret);
	}, [isSup]);

	React.useEffect(() => {
		if (!count.current) {
			let gen_items = getItems();
			count.current = gen_items.length;
			if (gen_items?.length === 1 && !active)
				setActive(gen_items[0]);
		}
	}, [count, setActive, active, isSup, getItems]);

	const handleClose = () => {
		if (active && items?.length > 1 && count.current > 1)
			setActive(false);
		else
			props.handleClose();
	};

	let list = getItems();

	if (!list?.length)
		return (false);

	return (
		<div className="UsersManager gap-4 overflow-auto">
			<div className="d-flex align-items-center gap-2">
				<BackButton onClick={handleClose} />
				<h4>{t(active?.title || "Contacts.HANDLE_USERS")}</h4>
			</div>
			<Filters {...props} />
			{
				active ?
					<active.component users={props.users} selected={props.selected} {...active.props} />
					:
					<div>
						<div className="d-flex flex-wrap mt-4 gap-2">
							{
								list.map((a) => {
									return (<ManagerItem key={a.key} {...a} onClick={() => setActive(a)} />);
								})
							}
						</div>
					</div>
			}
		</div>
	);
}

function Filters(props) {
	const genTitle = () => {
		let ret = [];

		if (props.search)
			ret.push(`- ${t('Contacts.SEARCH_RESULTS')}: "${props.search}"`);
		if (props.showSaved)
			ret.push(`- ${t('Contacts.FAVORITES_USERS')}`);
		if (props.userState !== false)
			ret.push("- " + (props.userState === "actives" ? t('Contacts.ACTIVE_USERS') : t('Contacts.INACTIVE_USERS')));
		if (props.site)
			ret.push(<SiteList siteId={props.site.value} />);
		if (props.groups?.length)
			ret.push(<GroupsList groups={props.groups} />);
		return (ret);
	};

	let title = genTitle();

	if (!title.length)
		return (false);

	return (
		<div className="Filters">
			<div className="d-flex align-items-center gap-2">
				<h4><FontAwesomeIcon icon={faExclamationTriangle} color={"orange"} /></h4>
				<h5>{t('Contacts.FILTERS_APPLIES')}</h5>
			</div>
			<div className="mt-1" style={{ fontSize: "1em" }}>
				<b>{props.users?.length}</b> {t('Contacts.SELECTABLE_USERS')}</div>
			<hr />
			{title.map((a, key) => <div key={key}>{a}</div>)}
		</div>
	);
}

function SiteList(props) {
	return (
		<div>
			<InfosFetcher
				queryKey={["Sites", props.siteId]}
				queryFn={() => genRequest("sites/" + props.siteId)}
				treat={(resp) => {
					return (<div>- {t("Contacts.BELONGING_SITE")} <b>"{resp.siteName + (resp.town ? " -  " + resp.town : "")}"</b></div>);
				}}
			/>
		</div>
	);
}

function GroupsList(props) {
	const { account } = useAccount();
	if (!props.groups?.length)
		return (false);
	return (
		<div>
			- {t("Contacts.PART_OF")}:
			<InfosFetcher
				queryKey={["Groups", "OfCompany", account.companyId]}
				queryFn={() => genRequest("groups/company/" + account.companyId)}
				treat={(items) => {
					if (!items?.length)
						return (false);
					let treated = items.map((a) => (props.groups.indexOf(a.id) !== -1 ? {
						color: a.defaultHexaColor,
						text: a.groupName
					} : false))
						.filter(a => a);

					return (
						<TagsList
							className={"ms-2"}
							sortBy={"text"}
							items={treated}
						/>
					);
				}}
			/>
		</div>
	);
}

function ManagerItem(props) {
	return (
		<Button className="ManagerItem btn-h-blue gap-2" onClick={props.onClick} disabled={props.disabled ? true : false}>
			<FontAwesomeIcon icon={props.icon} />
			{t(props.title)}
		</Button>
	);
}
